export default __webpack_public_path__ + "static/media/taref.117fe22f.png";